import sha256 from 'crypto-js/sha256'

/**
 * Hashes a string using SHA256 algorithm.
 * @param {string} string - The string to hash.
 * @returns {string} - The hashed string.
 */
export function hashSha256(string) {
	return sha256(string).toString()
}
